"use client";

import { motion, useAnimation } from "framer-motion";
import { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
const RECT_1_VARIANTS = {
  normal: {
    translateX: 0,
    translateY: 0
  },
  animate: {
    translateX: [0, 11, 11, 0],
    translateY: [0, 0, 0, 0],
    transition: {
      duration: 0.8,
      ease: "easeInOut",
      times: [0, 0.4, 0.6, 1]
    }
  }
};
const RECT_2_VARIANTS = {
  normal: {
    translateX: 0,
    translateY: 0
  },
  animate: {
    translateX: [0, 0, 0, 0],
    translateY: [0, 11, 11, 0],
    transition: {
      duration: 0.8,
      ease: "easeInOut",
      times: [0, 0.4, 0.6, 1]
    }
  }
};
const RECT_3_VARIANTS = {
  normal: {
    translateX: 0,
    translateY: 0
  },
  animate: {
    translateX: [0, -11, -11, 0],
    translateY: [0, 0, 0, 0],
    transition: {
      duration: 0.8,
      ease: "easeInOut",
      times: [0, 0.4, 0.6, 1]
    }
  }
};
const RECT_4_VARIANTS = {
  normal: {
    translateX: 0,
    translateY: 0
  },
  animate: {
    translateX: [0, 0, 0, 0],
    translateY: [0, -11, -11, 0],
    transition: {
      duration: 0.8,
      ease: "easeInOut",
      times: [0, 0.4, 0.6, 1]
    }
  }
};
const LayoutGridIcon = forwardRef(({
  onMouseEnter,
  onMouseLeave,
  className,
  size = 28,
  ...props
}, ref) => {
  const controls = useAnimation();
  const isControlledRef = useRef(false);
  useImperativeHandle(ref, () => {
    isControlledRef.current = true;
    return {
      startAnimation: () => controls.start("animate"),
      stopAnimation: () => controls.start("normal")
    };
  });
  const handleMouseEnter = useCallback(e => {
    if (isControlledRef.current) {
      onMouseEnter?.(e);
    } else {
      controls.start("animate");
    }
  }, [controls, onMouseEnter]);
  const handleMouseLeave = useCallback(e => {
    if (isControlledRef.current) {
      onMouseLeave?.(e);
    } else {
      controls.start("normal");
    }
  }, [controls, onMouseLeave]);
  return <div className="contents" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} {...props}>
        <svg className={className} fill="none" height={size} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg">
          <motion.rect animate={controls} height="7" initial="normal" rx="1" variants={RECT_1_VARIANTS} width="7" x="3" y="3" />
          <motion.rect animate={controls} height="7" initial="normal" rx="1" variants={RECT_2_VARIANTS} width="7" x="14" y="3" />
          <motion.rect animate={controls} height="7" initial="normal" rx="1" variants={RECT_3_VARIANTS} width="7" x="14" y="14" />
          <motion.rect animate={controls} height="7" initial="normal" rx="1" variants={RECT_4_VARIANTS} width="7" x="3" y="14" />
        </svg>
      </div>;
});
LayoutGridIcon.displayName = "LayoutGridIcon";
export { LayoutGridIcon };
